export default "__VITE_ASSET__e78842ad__"